import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { Breadcrumbs, P } from "../../AbstractElements";
import CommonCardHeader from "../CommonComponents/CommonCardHeader/CommonCardHeader";

const DashboardContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle="Dashboard" parent="HRIS" />
      <Container fluid>
        <Row></Row>
      </Container>
    </>
  );
};

export default DashboardContainer;
